import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const unarchiveTrial = async ({ trialId }) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${__API_URL__}/api/photos/trials/${trialId}/unarchive/`,
    {},
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

const useUnarchiveTrialMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: unarchiveTrial,
    onSuccess: (_data, { trialId }) => {
      queryClient.invalidateQueries({ queryKey: ["summary_trial", trialId] });
      queryClient.invalidateQueries({ queryKey: ["trials_list"] });
    },
  });
};

export default useUnarchiveTrialMutation;
